var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailManagementLightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8842",
    "data-name": "Group 8842",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.609,
    height: 14.007,
    viewBox: "0 0 19.609 14.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9692",
    "data-name": "Path 9692",
    d: "M9.868,972.362A1.874,1.874,0,0,0,8,974.23V984.5a1.874,1.874,0,0,0,1.868,1.868H25.742a1.874,1.874,0,0,0,1.868-1.868V974.23a1.874,1.874,0,0,0-1.868-1.868Zm0,.934H25.742a.937.937,0,0,1,.248.036l-7.543,7.609a.9.9,0,0,1-1.3,0l-7.521-7.616A.951.951,0,0,1,9.868,973.3Zm-.9.7,5.559,5.625-5.552,5.15a.946.946,0,0,1-.044-.27V974.23A.946.946,0,0,1,8.97,974Zm17.669,0a.946.946,0,0,1,.036.233V984.5a.946.946,0,0,1-.044.27l-5.552-5.158L26.639,974Zm-6.223,6.281,5.53,5.128a.947.947,0,0,1-.2.029H9.868a.947.947,0,0,1-.2-.029l5.522-5.121,1.3,1.313a1.85,1.85,0,0,0,2.626,0l1.306-1.32Z",
    transform: "translate(-8 -972.362)",
    fill: "#a3e3d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailManagementLightIcon);
export default __webpack_public_path__ + "static/media/email-management-light-icon.42c2141837551e435e933b46d39b0a55.svg";
export { ForwardRef as ReactComponent };